import {
  GET_CHECK_OUT_REQUEST,
  GET_CHECK_OUT_SUCCESS,
  GET_CHECK_OUT_FAIL,
} from "../../types/admin/checkOutTypes";

export const getCheckOutReducer = (state = { notifications: [] }, action) => {
  switch (action.type) {
    case GET_CHECK_OUT_REQUEST:
      return { loading: true, notifications: [] };

    case GET_CHECK_OUT_SUCCESS:
      return {
        loading: false,
        notifications: action.payload?.userCheckOut || [],
      };

    case GET_CHECK_OUT_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
